import { Fragment } from 'react'

import { Icon } from '@fv/client-components'
import { addressFuncs } from '@fv/client-core'
import type { PropsWithLoad } from '@fv/client-types'

import { ShipperSlider } from '@/components/ShipperSlider'
import {
  ItemSummary,
  MissingItemSummary,
} from '@/features/commodities/ItemSummary'
import { getItemsForSequence } from '@/utils/shipmentFuncs'

import { List, ListItem } from '../List'
import { Pinline } from '../Pinline'

type Props = PropsWithLoad<{
  activeIndex: number
  isOpen: boolean
  numberOfTrucks: number
  setOpen: (open: boolean) => void
}>

export const ItemSummaryPanel = ({
  activeIndex,
  isOpen,
  load,
  numberOfTrucks,
  setOpen,
}: Props) => {
  const { locations } = load

  return (
    <ShipperSlider onClose={() => setOpen(false)} isOpen={isOpen}>
      {locations.map((x, ix) => {
        const isMultiStop = locations.length > 2
        if (!isMultiStop && ix === 0) return null
        const items = getItemsForSequence(x.sequence, load.items)

        return (
          <Fragment key={ix}>
            <List className="mb-4">
              {(isMultiStop || x.type === 'destination') && (
                <ListItem>
                  <p className="mb-0 flex flex-nowrap items-start">
                    <Icon
                      icon="map-marker"
                      className="text-fv-gray-dark flex-none"
                      transform="down-2.5"
                    />
                    <span>{addressFuncs.companyAddress(x)}</span>
                  </p>
                </ListItem>
              )}

              {numberOfTrucks > 1 && (
                <ListItem>
                  <Icon icon="truck" className="text-fv-gray-dark" />
                  <span>Truck {activeIndex + 1}</span>
                </ListItem>
              )}

              {!items.length ? (
                <MissingItemSummary />
              ) : (
                items.map(i => (
                  <ItemSummary
                    iconClassName="flex-none"
                    item={i}
                    key={i._id}
                    label={
                      i.pickupLocationSequence === x.sequence
                        ? 'Picking up'
                        : 'Delivering'
                    }
                    contains={i.contains}
                  />
                ))
              )}
            </List>

            {ix !== locations.length - 1 && (
              <Pinline rule className="border-t-fv-orange" />
            )}
          </Fragment>
        )
      })}
    </ShipperSlider>
  )
}
